import StumblrLogo from "../assets/stumblr-logo.png";
import StumblrLaunch from "../assets/screenshots/stumblr-screenshots/1.png";
import StumblrScreenshot2 from "../assets/screenshots/stumblr-screenshots/2.png";
import StumblrScreenshot3 from "../assets/screenshots/stumblr-screenshots/3.png";
import StumblrScreenshot4 from "../assets/screenshots/stumblr-screenshots/4.png";
import StumblrScreenshot5 from "../assets/screenshots/stumblr-screenshots/5.png";
import StumblrScreenshot6 from "../assets/screenshots/stumblr-screenshots/6.png";
import StumblrScreenshot7 from "../assets/screenshots/stumblr-screenshots/7.png";
import StumblrScreenshot8 from "../assets/screenshots/stumblr-screenshots/8.png";
import StumblrScreenshot9 from "../assets/screenshots/stumblr-screenshots/9.png";
import StumblrScreenshot10 from "../assets/screenshots/stumblr-screenshots/10.png";
import StumblrScreenshot11 from "../assets/screenshots/stumblr-screenshots/11.png";
import StumblrScreenshot12 from "../assets/screenshots/stumblr-screenshots/12.png";

import MyNexusLogo from "../assets/mynexus.png";
import MyNexusScreenshot1 from "../assets/screenshots/mynexus-1-min.png";
import MyNexusScreenshot2 from "../assets/screenshots/mynexus-2-min.png";
import MyNexusScreenshot3 from "../assets/screenshots/mynexus-3-min.png";
import MyNexusScreenshot4 from "../assets/screenshots/mynexus-4-min.png";
import MyNexusScreenshot5 from "../assets/screenshots/mynexus-5-min.png";
import MyNexusScreenshot6 from "../assets/screenshots/mynexus-6-min.png";

import MPForAWeekLogo from "../assets/mpforaweek.png";
import MPForAWeekScreenshot1 from "../assets/screenshots/mpforaweek-1-min.png";
import MPForAWeekScreenshot2 from "../assets/screenshots/mpforaweek-2-min.png";
import MPForAWeekScreenshot3 from "../assets/screenshots/mpforaweek-3-min.png";
import MPForAWeekScreenshot4 from "../assets/screenshots/mpforaweek-4-min.png";
import MPForAWeekScreenshot5 from "../assets/screenshots/mpforaweek-5-min.png";
import MPForAWeekScreenshot6 from "../assets/screenshots/mpforaweek-6-min.png";
import MPForAWeekScreenshot7 from "../assets/screenshots/mpforaweek-7-min.png";

import CaffeindLogo from "../assets/caffeind.png";
import CaffeindLaunch from "../assets/screenshots/caffeind_launch.png";

import PoolsIcon from "../assets/pools-icon.png";
import PoolsScreenshot1 from "../assets/screenshots/pools-screenshots/1.png";
import PoolsScreenshot2 from "../assets/screenshots/pools-screenshots/2.png";
import PoolsScreenshot3 from "../assets/screenshots/pools-screenshots/3.png";
import PoolsScreenshot4 from "../assets/screenshots/pools-screenshots/4.png";
import PoolsScreenshot5 from "../assets/screenshots/pools-screenshots/5.png";
import PoolsScreenshot6 from "../assets/screenshots/pools-screenshots/6.png";
import PoolsScreenshot7 from "../assets/screenshots/pools-screenshots/7.png";
import PoolsScreenshot8 from "../assets/screenshots/pools-screenshots/8.png";

import GardiniaIcon from "../assets/gardinia-icon.png";
import GardiniaScreenshot1 from "../assets/screenshots/gardinia-screenshots/1.png";
import GardiniaScreenshot2 from "../assets/screenshots/gardinia-screenshots/2.png";
import GardiniaScreenshot3 from "../assets/screenshots/gardinia-screenshots/3.png";
import GardiniaScreenshot4 from "../assets/screenshots/gardinia-screenshots/4.png";
import GardiniaScreenshot5 from "../assets/screenshots/gardinia-screenshots/5.png";

export const appData = {
  stumblr: {
    key: "stumblr",
    title: "Stumblr",
    logo: StumblrLogo,
    active: true,
    links: {
      download: "/apps/stumblr",
    },
    description: `Stumblr is a pub crawl app that allows the user to filter their local area for pubs based on various features, be it dog-friendly, sunday roasts or pool tables, and tick them off as they go. 
    
    The user can create their own pub crawls or gain inspiration from others created by other users.`,
    screenshots: [
      StumblrLaunch,
      StumblrScreenshot2,
      StumblrScreenshot3,
      StumblrScreenshot4,
      StumblrScreenshot5,
      StumblrScreenshot6,
      StumblrScreenshot7,
      StumblrScreenshot8,
      StumblrScreenshot9,
      StumblrScreenshot10,
      StumblrScreenshot11,
      StumblrScreenshot12,
    ],
    type: "app",
  },
  tastd: {
    key: "tastd",
    title: "Tastd",
    logo: "",
    active: false,
    links: {
      appStore: "",
      playStore: "",
    },
    description: "",
    screenshots: [],
    type: "app",
  },
  mynexus: {
    key: "mynexus",
    title: "My Nexus Entrepeneur Skills Index",
    logo: MyNexusLogo,
    active: true,
    links: {
      appStore:
        "https://apps.apple.com/gb/app/entrepreneur-skills-index/id1512976589",
      playStore:
        "https://play.google.com/store/apps/details?id=com.mynexus.coffeeenterprise&hl=en_GB",
    },
    description: `My Nexus Entrepeneur Skills Index was designed and envisioned by myNexus Limited to help younger users to play an entrepeneurial game with the long term goal to link them with investors and other entrepeneurs. 
    
    The user must run a coffee shop and manage staff, stock and unexpected circumstances to increase revenue and profits, with a game algorithm created by myself and developed in collaboration for fishinabottle.`,
    screenshots: [
      MyNexusScreenshot1,
      MyNexusScreenshot2,
      MyNexusScreenshot3,
      MyNexusScreenshot4,
      MyNexusScreenshot5,
      MyNexusScreenshot6,
    ],
    type: "app",
  },
  mpforaweek: {
    key: "mpforaweek",
    title: "MP for a Week",
    logo: MPForAWeekLogo,
    active: true,
    links: {
      site: "https://learning.parliament.uk/en/resources/mp-for-a-week/",
    },

    description: `MP for a Week was developed by myself for parliament through fishinabottle, the game is a fully accessible game and was created to the highest of the WCAG standard. 
    
    The user takes the role of an MP participating in debates, press days and meetings to gain voter support and increase their media and party scores. mechanics and design are not mine.`,
    screenshots: [
      MPForAWeekScreenshot1,
      MPForAWeekScreenshot2,
      MPForAWeekScreenshot3,
      MPForAWeekScreenshot4,
      MPForAWeekScreenshot5,
      MPForAWeekScreenshot6,
      MPForAWeekScreenshot7,
    ],
    type: "website",
  },
  caffeind: {
    key: "caffeind",
    title: "Caffeind",
    logo: CaffeindLogo,
    active: true,
    links: {
      appStore: "",
      playStore: "",
    },
    description: "",
    screenshots: [CaffeindLaunch],
    type: "app",
  },
  pools: {
    key: "pools",
    title: "Pools",
    logo: PoolsIcon,
    active: true,
    links: {
      download: "/apps/pools",
    },
    description: `Pools is a personal link and task storage system designed to ease the mental load of keeping track of everything you find online. Save links of any type — recipes from Instagram, articles, websites, images, videos — all in one place, organised into oceans and pools.

Use it as a reference library or a to-do list you can tick off as you go. No more losing that recipe you saw last week or forgetting the article you meant to read.`,
    screenshots: [
      PoolsScreenshot1,
      PoolsScreenshot2,
      PoolsScreenshot3,
      PoolsScreenshot4,
      PoolsScreenshot5,
      PoolsScreenshot6,
      PoolsScreenshot7,
      PoolsScreenshot8,
    ],
    type: "app",
  },
  gardinia: {
    key: "gardinia",
    title: "Gardinia",
    logo: GardiniaIcon,
    active: true,
    links: {
      // download: "/apps/gardinia",
    },
    description: `Gardinia is a personal garden companion built to help you grow fruit, vegetables, and flowers at your own pace. Tell it what you're growing and it gives you daily tailored advice on when to water, prune, harvest, and plant next.

Designed for real gardens, not generic tips — Gardinia learns your space and keeps you one step ahead of the season.`,
    screenshots: [
      GardiniaScreenshot1,
      GardiniaScreenshot2,
      GardiniaScreenshot3,
      GardiniaScreenshot4,
      GardiniaScreenshot5,
    ],
    type: "app",
  },
};
